// extracted by mini-css-extract-plugin
export default {"icon-default":"IconButton_icon-default__8Av7n","icon-filled":"IconButton_icon-filled__xniVX","icon-btn":"IconButton_icon-btn__b6RNO"};